import { AuthServiceModule } from 'services/auth/auth.service';
import { CheckoutServiceModule } from '../../checkout.service';
import template from './accountForm.html';
import './accountForm.scss';

export const CheckoutAccountFormModule =
    angular.module('app.components.checkout.components.checkoutAccountForm', [
        AuthServiceModule,
        CheckoutServiceModule
    ]).component('checkoutAccountForm', {
        template,
        bindings: {
            coupon: '<',
            couponCode: '<',
            user: '<',
            cart: '<',
            onSignupFormValidityChange: '&',
            onLogout: '&',
            onCouponEntered: '&',
            onPaymentMethodSelected: '<',
            showCouponField: '<',
            purchaseComplete: '<',
            hasAccount: '<'
        },
        controller: class CheckoutAccountFormCtrl {
            constructor(checkoutService, authService) {
                'ngInject';

                angular.extend(this, {
                    hasAccount: false,
                    checkoutService,
                    authService
                });
            }

            $onInit() {
                this.preLoggedIn = angular.copy(this.user.isLoggedIn);
            }

            onAccountChange() {
                if (this.user.isLoggedIn && !this.hasAccount) {
                    this.logout();
                }
            }

            logout() {
                this.authService.clearUser();
                this.onLogout();
            }

            setHasAccount(hasAccount) {
                this.hasAccount = hasAccount;
                this.onAccountChange();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/components/accountForm/accountForm.js